import { h } from '@atomify/jsx';
import { Image } from '@atoms/image';
import { COLOR_CLASSES, FormattedPrice, FormattedStatus } from '@source/utilities/api-formatters';

interface PropertyCardInterface {
    number?: string | null;
    title: string;
    id?: string;
    project?: string | null;
    image?: string | null;
    href?: string;
    price?: FormattedPrice;
    specs?: string[];
    status?: FormattedStatus;
    wishlistItemCount?: number;
    classes?: string;
    hidePrice?: boolean;
    debugId?: string;
    orientation?: 'horizontal' | 'vertical';
}

export const PropertyCard = (data: PropertyCardInterface) => {
    const {
        classes = '',
        href,
        id,
        image,
        title,
        number,
        status,
        price,
        specs,
        project,
        wishlistItemCount,
        hidePrice,
        debugId,
        orientation,
    } = data;

    const { hasWishlist } = window.__ENVIRONMENT_DETAILS__;

    const classList = {
        ['c-property-card']: true,
        [classes]: true,
        ...(orientation && { [`property-card--${orientation}`]: true }),
    };

    return (
        <a class={classList} href={href} {...(id && { id })}>
            {debugId && <span class="property-card__debug-id">{debugId}</span>}
            <div class="property-card__image-container">
                {image && (
                    <Image
                        image={image}
                        settings={{
                            '640w': {
                                width: 232,
                                height: 144,
                            },
                        }}
                        classes="property-card__image"
                        alt={`${title} ${project}`}
                        objectFit={true}
                    />
                )}
                {hasWishlist && wishlistItemCount && (
                    <bpd-wishlist-favourite-button
                        construction-number-id={id}
                        count={wishlistItemCount}
                    />
                )}
            </div>
            {number && (
                <div class="u-flex u-flex-center">
                    <span class="property-card__number">{number}</span>
                </div>
            )}

            <div class="property-card__details">
                {status && (
                    <span class={`property-card__status ${COLOR_CLASSES[status.color]}`}>
                        {status.label}
                    </span>
                )}

                <h3 class="property-card__title">{title}</h3>

                {price?.amount && !hidePrice && (
                    <div class="property-card__price">
                        {price.prefix && price.prefix} {price.amount && price.amount}{' '}
                        {price.suffix && price.suffix}
                    </div>
                )}

                {specs && (
                    <ul class="property-card__specs">
                        {specs.map((spec) => (
                            <li class="property-card__spec">{spec}</li>
                        ))}
                    </ul>
                )}

                {project && <span class="property-card__project">{project}</span>}
            </div>
        </a>
    );
};
